<style scoped>

</style>

<template>
	<v-expansion-panel>
		<v-expansion-panel-header class="blue--text">
			Addresses
		</v-expansion-panel-header>
		<v-expansion-panel-content>
			<v-row no-gutters>
				<v-skeleton-loader
					v-if="loading"
					type="list-item-two-line"
				/>
				<v-col cols="12" md="4" class="pa-1"
					v-for="address in addresses"
					v-bind:key="address.id"
				>
					<v-card 
						outlined
						elevation="0"
					>		
						<div class="d-flex flex-no-wrap justify-space-between">
							<div>
								<div 
									class="
										text-caption
										text-uppercase
										text--secondary
										font-weight-normal
										pa-4 pb-3"
								>
									{{address.type_desc}}
								</div>
								<div class="text-body-2 pl-4">
									<span v-if = "address.street_no!=''">{{address.street_no}}, </span>
									<span>{{address.street_name}}</span>
								</div>
								<div class="text-body-2 pl-4" >{{address.adress_line1}}</div>
								<div class="text-body-2 pl-4" >{{address.adress_line2}}</div>
								<div class="text-body-2 pl-4" >{{address.town}}</div>
								<div class="text-body-2 pl-4 pb-4">{{address.state}}, {{address.country.display_name}} {{address.postcode}}</div>
							</div>
						</div>
					</v-card>

				</v-col>
			</v-row>
		</v-expansion-panel-content>
		
	</v-expansion-panel>
</template>

<script>
export default {
	props: {
		is_expanded: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			abook_id: 0,
			errormsg: '',
			loading: false,
			is_loaded: false,
			addresses:[]
		}
	},
	methods: {
		load(abook_id) {
			this.abook_id = abook_id;
			if (this.is_expanded) {
				this.do_search()
			} else {
				this.is_loaded = false;
			}

		},
		do_search() {
			this.is_loaded = true;

			this.errormsg = '';
			this.loading = true;
			this.addresses = [];
			let self = this;


			// load our addressbook
			let url = "/api/addressbook/" + this.abook_id + "/addresses";
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						self.addresses = json.data;
						
					} else {
						self.errormsg = json.reason;
						console.log(self.errormsg);
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading = false;
				});
		},
	},
	watch: {
		'is_expanded': function(new_value) {
			if (new_value && !this.is_loaded) {
				this.do_search();
			}
		}
	}
}
</script>
